import React, { useRef, useState } from "react";
import { copyToClipBoard, generatePassword } from "../../utils/Helper";
import ToolTip from "../../utils/ToolTip/ToolTip";
import { Container } from "../container/Container";
import Button from "../elements/button/Button";
import "./Display.css";

const Display = () => {
  const [password, setPassword] = useState("");
  const [rangeValue, setRange] = useState();
  const [passwordProps, setPasswordProps] = useState();
  const [type, setType] = useState("password");
  const passwordRef = useRef(null);

  const [toolTip, setTooltip] = useState(false);

  let pwdDescription = "";

  const generateNewPassword = () => {
    const pwd =
      rangeValue > 3
        ? generatePassword(passwordProps, rangeValue)
        : generatePassword(passwordProps, 3);
    setPassword(pwd);
  };

  const copyClipBoard = (e) => {
    e.preventDefault();
    copyToClipBoard(passwordRef.current);
    setTooltip(true);
    setTimeout(() => {
      setTooltip(false);
    }, 2000);
  };

  const setBackgroundColor = (password) => {
    if (password && password.length === 1 && password.length <= 5) {
      pwdDescription = "Bad Password";
      return "#cb473e";
    } else if (password && password.length >= 6 && password.length <= 10) {
      pwdDescription = "Weak Password";
      return "#f07d58";
    } else if (password && password.length > 10) {
      pwdDescription = "Strong Password";
      return "#55a95d";
    } else {
      pwdDescription = "Bad Password";
      return "#cb473e";
    }
  };

  const onSelectTag = (e) => {
    setType(e.target.value);
  };

  return (
    <>
      <div className="select-class">
        <select
          name="type"
          value={type}
          onChange={onSelectTag}
          className="form-control form-control-sm"
          style={selectTagStyle}
        >
          <option value="password">Random Password</option>
          <option value="pin">PIN</option>
        </select>
      </div>
      <div className="row">
        <div className="col-12 password-display-container">
          <div style={{ width: "100%" }}>
            <div className="password-display">
              <input
                ref={passwordRef}
                type="text"
                className="password-display-input"
                value={password}
                readOnly
                style={{ backgroundColor: setBackgroundColor(password) }}
              />
              <div className="password-diplay-icons">
                <Button
                  className="copy-btn"
                  iconClass="fa fa-copy"
                  handleClick={(e) => copyClipBoard(e)}
                />
                <Button
                  className="generate-btn"
                  iconClass="fa fa-refresh"
                  handleClick={() => generateNewPassword()}
                />
              </div>
              <div className="password-diplay-copy">
                <Button
                  className="btn password-btn"
                  label="Copy"
                  handleClick={(e) => copyClipBoard(e)}
                />
              </div>
            </div>
            <ToolTip
              message="Copied"
              position="top-right"
              displayTooltip={toolTip}
            />

            <div className="col-4 mt-4 ml-2 password-description">
              {password && password.length > 10 ? (
                <>
                  <i className="fa fa-check-circle"></i> {pwdDescription}
                </>
              ) : (
                <>
                  <i className="fa fa-exclamation-circle"></i> {pwdDescription}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <Container
        setPassword={setPassword}
        setRange={setRange}
        setPasswordProps={setPasswordProps}
        type={type}
      />
    </>
  );
};

const selectTagStyle = {
  backgroundColor: "inherit",
  color: "#506175",
  width: "20%",
  height: "auto",
  marginLeft: "-4px",
};

export default Display;
